export default {
  path: '/help-pages',
  name: 'r_help-pages',
  component: () => import('../../components/help-pages/HelpPages'),
  children: [
    // add page
    {
      path: 'add-page',
      name: 'r_help-pages-add-help-page',
      props: {
        backLinkName: 'r_help-pages',
      },
      component: () => import('../../components/help-pages/AddHelpPage'),
      children: [
        {
          path: 'select-language',
          name: 'r_help-pages-add-help-page-select-language',
          props: {
            backLinkName: 'r_help-pages-add-help-page',
            componentTitle: 'select-language',
            componentLabel: 'name-translation',
          },
          component: () => import('../../components/help-pages/SelectLanguage'),
        },
      ],
    },
    // edit page
    {
      path: ':helpPageId',
      name: 'r_help-pages-edit-help-page',
      props: {
        backLinkName: 'r_help-pages',
      },
      component: () => import('../../components/help-pages/EditHelpPage'),
      children: [
        {
          path: 'select-language',
          name: 'r_help-pages-edit-help-page-select-language',
          props: {
            backLinkName: 'r_help-pages-edit-help-page',
            componentTitle: 'select-language',
            componentLabel: 'name-translation',
          },
          component: () => import('../../components/help-pages/SelectLanguage'),
        },
      ],
    },
    // css
    {
      path: 'css',
      name: 'r_help-pages-css',
      props: {
        backLinkName: 'r_help-pages',
      },
      component: () => import('../../components/help-pages/EditCss'),
    },
  ],
};
